import PropTypes from 'prop-types';

const menuShape = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  name: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  onClick: PropTypes.func,
});

export { menuShape };
